import { useEffect as o } from "react";
import { enUS as t } from "date-fns/locale/en-US";
import { LanguageCodeEnum as r } from "@systemeio/types";
const k = (i, e) => {
  o(() => {
    (async () => {
      try {
        if (i) {
          let a;
          switch (i) {
            case r.ENGLISH:
              a = t;
              break;
            case r.CHINESE:
              a = (await import("date-fns/locale/zh-CN")).zhCN;
              break;
            case r.ARABIC:
              a = (await import("date-fns/locale/ar")).ar;
              break;
            case r.CZECH:
              a = (await import("date-fns/locale/cs")).cs;
              break;
            case r.DANISH:
              a = (await import("date-fns/locale/da")).da;
              break;
            case r.DEUTSCH:
              a = (await import("date-fns/locale/de")).de;
              break;
            case r.GREEK:
              a = (await import("date-fns/locale/el")).el;
              break;
            case r.SPANISH:
              a = (await import("date-fns/locale/es")).es;
              break;
            case r.FRENCH:
              a = (await import("date-fns/locale/fr")).fr;
              break;
            case r.HINDI:
              a = (await import("date-fns/locale/hi")).hi;
              break;
            case r.HUNGARIAN:
              a = (await import("date-fns/locale/hu")).hu;
              break;
            case r.INDONESIAN:
              a = (await import("date-fns/locale/id")).id;
              break;
            case r.ITALIAN:
              a = (await import("date-fns/locale/it")).it;
              break;
            case r.JAPANESE:
              a = (await import("date-fns/locale/ja")).ja;
              break;
            case r.NORWEGIAN:
              a = (await import("date-fns/locale/nb")).nb;
              break;
            case r.DUTCH:
              a = (await import("date-fns/locale/nl")).nl;
              break;
            case r.POLISH:
              a = (await import("date-fns/locale/pl")).pl;
              break;
            case r.PORTUGUESE:
              a = (await import("date-fns/locale/pt")).pt;
              break;
            case r.ROMANIAN:
              a = (await import("date-fns/locale/ro")).ro;
              break;
            case r.RUSSIAN:
              a = (await import("date-fns/locale/ru")).ru;
              break;
            case r.SLOVAK:
              a = (await import("date-fns/locale/sk")).sk;
              break;
            case r.SLOVENIAN:
              a = (await import("date-fns/locale/sl")).sl;
              break;
            case r.ALBANIA:
              a = (await import("date-fns/locale/sq")).sq;
              break;
            case r.SERBIAN:
              a = (await import("date-fns/locale/sr")).sr;
              break;
            case r.SWEDISH:
              a = (await import("date-fns/locale/sv")).sv;
              break;
            case r.THAI:
              a = (await import("date-fns/locale/th")).th;
              break;
            case r.TURKISH:
              a = (await import("date-fns/locale/tr")).tr;
              break;
            case r.UKRAINIAN:
              a = (await import("date-fns/locale/uk")).uk;
              break;
            default:
              a = t;
              break;
          }
          e(a);
        } else
          e(t);
      } catch (a) {
        console.error("Error loading locale:", a), e(t);
      }
    })();
  }, [i, e]);
};
export {
  k as useDateFnsLocale
};
